// Actions
/**
 * Identifies the origin of fetched MRU data so service-assigned IDs can be distinguished
 * from legacy IDs restored from the client cache.
 */ export var MruFetchSource = /*#__PURE__*/ function(MruFetchSource) {
    /** MRU data returned by the service. */ MruFetchSource["Service"] = "Service";
    /** MRU data restored from the persisted client cache. */ MruFetchSource["Cache"] = "Cache";
    return MruFetchSource;
}({});
